<div class="snackbar-box" [ngClass]="data.class">
    <mat-icon [ngClass]="data.titleClass">
        {{ data.type }}
    </mat-icon>
    <div class="snackbar-description-txt">
        <p class="snackbar-title-message mb-0" [ngClass]="data.titleClass">
            {{ data.heading }}
        </p>
        <p class="snackbar-sub-txt mb-0">
            {{ data.description }}
        </p>
        @if (data.isButton) {
            <button
                mat-flat-button
                color="primary"
                type="button"
                class="border-btn mt-4"
                (click)="snackbar.dismiss()"
                (keydown)="snackbar.dismiss()"
            >
                Check email
            </button>
        }
    </div>
    <mat-icon class="cancel-icon" (click)="snackbar.dismiss()" (keydown)="snackbar.dismiss()">
        <span class="material-symbols-outlined">close</span>
    </mat-icon>
</div>
